import {Injectable} from '@angular/core';
import {CarouselModel} from "../models/carousel.model";
import {ProviderModel} from "../models/provider.model";
import {Game} from "../models/game.class";

@Injectable({
  providedIn: 'root'
})
export class CarouselBuilderService {

  numOfSlides = 3;

  readonly carouselConfigs: CarouselModel[] = [
    {
      size: 'Xs',
      displayClass: 'd-block d-sm-none',
      itemsPerSlide: 3,
      sliceStart: (idx: number) => idx * 3,
      sliceEnd: (idx: number) => (idx + 1) * 3,
    },
    {
      size: 'Sm',
      displayClass: 'd-none d-sm-block d-md-none',
      itemsPerSlide: 4,
      sliceStart: (idx: number) => idx * 4,
      sliceEnd: (idx: number) => (idx + 1) * 4
    },
    {
      size: 'Md',
      displayClass: 'd-none d-md-block d-lg-none',
      itemsPerSlide: 5,
      sliceStart: (idx: number) =>  idx * 4,
      sliceEnd: (idx: number) => (idx + 1) * 4 + 1
    },
    {
      size: 'Lg',
      displayClass: 'd-none d-lg-block',
      itemsPerSlide: 6,
      sliceStart: (idx: number) => idx * 5,
      sliceEnd: (idx: number) => (idx+1) * 5+1
    }
  ];


  constructor() { }


  buildCarousels(dataList: ProviderModel[] | Game[]): CarouselModel[] {
    return this.carouselConfigs.map(c => {
      const newCarousel = {...c};
      newCarousel.slides = [];

      for (let i = 0; i < this.numOfSlides; i++) {
        let slide = dataList.slice(c.sliceStart(i), c.sliceEnd(i))
        if (slide.length) {
          //add placeholder if needed
          if (slide.length < c.itemsPerSlide) {
            let placeholders = Array(c.itemsPerSlide - slide.length).fill({});
            slide = [...slide, ...placeholders];
          }
          newCarousel.slides.push(slide)
        }
      }
      return newCarousel
    })
  }


}
